export default __webpack_public_path__ + "static/media/C2QB_green_btn_med_default.3874b7e5.svg";